export const getRandomDarkPastelColor = () => {
  const randomColor = () => Math.floor(Math.random() * 156) + 50; // Ensures lighter colors
  const r = randomColor();
  const g = randomColor();
  const b = randomColor();
  return `rgb(${r}, ${g}, ${b})`;
};
